import { transparentize } from 'polished';
import styled, { extensionsHook } from '../styled-components';
import { PropertyNameCell } from './fields-layout';
import { ShelfIcon } from './shelfs';
export const ClickablePropertyNameCell = styled(PropertyNameCell).withConfig({
  displayName: "fields__ClickablePropertyNameCell",
  componentId: "vqtjds-0"
})(["cursor:pointer;", "{height:", ";width:", ";polygon{fill:", ";}}"], ShelfIcon, ({
  theme
}) => theme.schema.arrow.size, ({
  theme
}) => theme.schema.arrow.size, ({
  theme
}) => theme.schema.arrow.color);
export const FieldLabel = styled.span.withConfig({
  displayName: "fields__FieldLabel",
  componentId: "vqtjds-1"
})(["vertical-align:middle;font-size:", ";line-height:20px;"], ({
  theme
}) => theme.typography.code.fontSize);
export const TypePrefix = styled(FieldLabel).withConfig({
  displayName: "fields__TypePrefix",
  componentId: "vqtjds-2"
})(["color:", ";"], props => transparentize(0.2, props.theme.schema.typeNameColor));
export const TypeName = styled(FieldLabel).withConfig({
  displayName: "fields__TypeName",
  componentId: "vqtjds-3"
})(["color:", ";"], props => props.theme.schema.typeNameColor);
export const TypeTitle = styled(FieldLabel).withConfig({
  displayName: "fields__TypeTitle",
  componentId: "vqtjds-4"
})(["color:", ";word-break:break-word;"], props => props.theme.schema.typeTitleColor);
export const TypeFormat = TypeName;
export const RequiredLabel = styled(FieldLabel.withComponent('div')).withConfig({
  displayName: "fields__RequiredLabel",
  componentId: "vqtjds-5"
})(["color:", ";font-size:", ";font-weight:normal;margin-left:20px;line-height:1;"], props => props.theme.schema.requireLabelColor, props => props.theme.schema.labelsTextSize);
export const RecursiveLabel = styled(FieldLabel).withConfig({
  displayName: "fields__RecursiveLabel",
  componentId: "vqtjds-6"
})(["color:", ";font-size:13px;"], ({
  theme
}) => theme.colors.warning.main);
export const NullableLabel = styled(FieldLabel).withConfig({
  displayName: "fields__NullableLabel",
  componentId: "vqtjds-7"
})(["color:#3195a6;font-size:13px;"]);
export const PatternLabel = styled(FieldLabel).withConfig({
  displayName: "fields__PatternLabel",
  componentId: "vqtjds-8"
})(["color:#3195a6;&::before,&::after{font-weight:400;}&::before{content:' /';}&::after{content:'/ ';}"]);
export const ExampleValue = styled(FieldLabel).withConfig({
  displayName: "fields__ExampleValue",
  componentId: "vqtjds-9"
})(["", ";& + &{margin-left:0;}", ";"], ({
  theme
}) => `
    background-color: ${transparentize(0.95, theme.colors.text.primary)};
    color: ${transparentize(0.1, theme.colors.text.primary)};

    margin: ${theme.spacing.unit}px;
    padding: 0 ${theme.spacing.unit}px;
    border: 1px solid ${transparentize(0.9, theme.colors.text.primary)};
    font-family: ${theme.typography.code.fontFamily};
}`, extensionsHook('ExampleValue'));
export const ExtensionValue = styled(ExampleValue).withConfig({
  displayName: "fields__ExtensionValue",
  componentId: "vqtjds-10"
})([""]);
export const ConstraintItem = styled(FieldLabel).withConfig({
  displayName: "fields__ConstraintItem",
  componentId: "vqtjds-11"
})(["", ";& + &{margin-left:0;}", ";"], ({
  theme
}) => `
    background-color: transparent;
    color: #4863BE;

    margin: 0 ${theme.spacing.unit}px;
    padding: 3px 8px;
    border: 1px solid #4863BE;
    border-radius: 16px 16px 16px 4px;
    font-family: ${theme.typography.code.fontFamily};
}`, extensionsHook('ConstraintItem'));